<div *ngIf="(isValidFund && !isHiddenFundId && !isInvalidFund && isInternalFund) || (nonVanguardFundsViewableFlag && isExternalFund)">
    <dashboard></dashboard>
    <div class="nav-tabs">
        <nav-tab-group [tickerOrFundId]="tickerOrFundId" [barChartSection]="barChartSection" [innerWidth]="innerWidth" [hasProxyVotingContent]="hasProxyVotingContent" [proxyVotingContent]="proxyVotingContent"></nav-tab-group>
    </div>
        <div class="profile-sections">
          <overview></overview>
          <performance></performance>
          <price></price>
          <portfolio></portfolio>
          <distributions *ngIf="!isExternalFund"></distributions>
          <fund-management *ngIf="!isExternalFund"></fund-management>
          <proxy-voting [proxyVotingContent]="proxyVotingContent" *ngIf="hasProxyVotingContent"></proxy-voting>
          <fund-literature *ngIf="!is529Fund && !isExternalFund"></fund-literature>
        </div>
        <disclosures></disclosures>
</div>

<div *ngIf= "!isValidFund || isHiddenFundId || isInvalidFund ||  !this.data?.fundProfile || (!nonVanguardFundsViewableFlag && isExternalFund)">
    <vmf-error></vmf-error>
</div>
 